import styled from 'styled-components';
import { Dropdown } from 'antd';

export const SwitchEnvStyled = styled(Dropdown as any)`
  position: fixed;
  right: 20px;
  bottom: 20px;
`;
